// extracted by mini-css-extract-plugin
export default {"container":"container--JVP6v"};